import { render, staticRenderFns } from "./ItemGenerator.vue?vue&type=template&id=0c406706&"
import script from "./ItemGenerator.vue?vue&type=script&lang=js&"
export * from "./ItemGenerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports